import { getLocalizedLogotypes } from "./getLocalizedLogotypes";

export { getLocalizedLogotypes };
